import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';

import {
  IRegisterRequestDto,
  IRegisterResponseDto,
  postRegister,
} from '@/shared/api/auth';
import { getRoutePath } from '@/shared/utils/routes';
import { resolvePartnerRef } from '@/shared/utils/partnerRef';

export const useRegister = () => {
  const navigate = useNavigate();

  const registerMutation = useMutation({
    mutationFn: (vars: IRegisterRequestDto) => postRegister(vars),
  });

  const mutate = (options: IRegisterRequestDto) => {
    const ref = resolvePartnerRef()
    return registerMutation.mutate(
      ref ? { ...options, ref } : options,
      {
        onSuccess: (response: IRegisterResponseDto) => {
          navigate(getRoutePath('AUTH', 'VERIFY_CODE'), {
            state: {
              token: response.auth_token,
              email: options.email,
            },
          });
        },
      },
    );
  };

  return {
    ...registerMutation,
    mutate,
  };
};
